import React, { useState } from "react";
import "../Assets/Css/ResetPassword.css";
import { POST_EXISTING_EMAIL_API } from "../Component/AllApi";
import hideIcon from "../Assets/Images/Dashboard/hide.png";
import showIcon from "../Assets/Images/Dashboard/show.png";
import logo from "../Assets/Images/Dashboard/reset-password-logo.png";
const ExistingEmail = () => {
  const [inputData, setInputData] = useState({
    email: ""
  });
  const [inputError, setInputError] = useState({});

  const [newPassVisible, setNewPassVisible] = useState(false);
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);

  const inputHandler = (event) => {
    const { name, value } = event.target;
    setInputData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const toggleNewPassVisibility = () => {
    setNewPassVisible(!newPassVisible);
  };

  const toggleConfirmPassVisibility = () => {
    setConfirmPassVisible(!confirmPassVisible);
  };

  const validateForm = () => {
    const error = {};
    const emailRegx = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9]+[.-][a-zA-Z][a-z.A-Z]+$/;

    const { email } = inputData;
    if (!email.trim()) {
      error.email = "Please enter email.";
    } else if (emailRegx.test(email) === false) {
      error.email = "Please enter valid email.";
    }
    setInputError(error);
    return Object.keys(error).length === 0;
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const isFormValid = validateForm();

    if (isFormValid) {
      try {
        let res = await fetch(POST_EXISTING_EMAIL_API, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: inputData.email,
          }),
        });
        let resJson = await res.json();
        // console.log("resjson", resJson);
        const msg = resJson.message;
        if (msg === "Password has been reset successfully") {
        }
        // console.log("msg", msg);
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <div className="container resetPassMain">
      <div className="card resetPassCard">
        <div className="card-body p-0">
          <div className="text-center">
            <img src={logo} alt="logo" />
          </div>{" "}
          {/* <p className="resetPass-title mt-5">Reset Password</p> */}
          <div className="mt-5">
            <form onSubmit={submitHandler}>
              <div className="pt-5">
                <label className="resetPass-label_text mb-1">Email</label>

                <div class="input-group mb-1">
                  <input
                    type={newPassVisible ? "text" : "password"}
                    class="form-control resetPassInput"
                    className="form-control resetPassInput"
                    onChange={inputHandler}
                    value={inputData.email}
                    name="email"
                    aria-label="Recipient's username"
                    aria-describedby="button-addon2"
                  />
                  <button
                    class="btn showPassBtn"
                    type="button"
                    id="button-addon2"
                  >
                    <img
                      src={newPassVisible ? showIcon : hideIcon}
                      alt="eye-icon"
                      className="eye_icon_reset_pass"
                      onClick={toggleNewPassVisibility}
                    />
                  </button>
                </div>
                <span className="error-msg">{inputError.email}</span>
              </div>

              <input
                type="submit"
                value="Submit"
                className="btn loginBtn w-100 mt-5"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExistingEmail;
